export const mods = {
	mod10: (number: string) => {
		const arr = [0, 2, 4, 6, 8, 1, 3, 5, 7, 9];

		let length = number.length;
		let bit = 1;
		let sum = 0;
		let val;

		while (length) {
			val = parseInt(number.charAt(--length), 10);
			sum += (bit ^= 1) ? arr[val] : val;
		}

		return sum && sum % 10 === 0;
	},
	mod11: (number: string) => {
		let length = number.length;
		let sum = 0;
		let val;

		const weights = [1, 10, 9, 8, 7, 6, 5, 4, 3, 2, 1];
		const arr = weights.splice(weights.length - length, weights.length - (weights.length - length));

		while (length) {
			val = parseInt(number.charAt(--length), 10);
			sum += arr[length] * val;
		}

		return sum && sum % 11 === 0;
	},
	mod97: (input: string) => {
		let checksum = parseInt(input.slice(0, 2), 10);
		let fragment;
		let offset = 2;
		const l = input.length;

		for (offset; offset < l; offset += 7) {
			fragment = String(checksum) + input.substring(offset, offset + 7);
			checksum = parseInt(fragment, 10) % 97;
		}

		return checksum;
	},
};
